const specificationSync = require("specification").SpecificationSync;

const createSpecification = function (isSatisfiedByFunction) {
    let specificationObject = function () {};
    specificationObject.prototype = Object.create(specificationSync);
    specificationObject.prototype.isSatisfiedBy = isSatisfiedByFunction;
    return specificationObject;
};

angular.module("FlexyBeautyApp.services")
    .factory("WebSiteSpecifications", [

        function() {
            let specifications = {};

            specifications.DisplayAllowChooseHrMessageSpecification = createSpecification(
                (allowChooseHr, isActiveLeCiseauOption) => {
                    return (!allowChooseHr && isActiveLeCiseauOption)
                }
            );

            return specifications;
        }]
    );


// WEBPACK FOOTER //
// ./js/specifications/website/WebSiteSpecifications.js